import React, { useContext, useState, useEffect } from "react";
import { MyProfileFirstSectionContainer } from "./MyProfileFirstSectionStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import gift from './../../utils/images/gift.svg';
import edit from './../../utils/images/edit.svg';
import ModalPrices from "../ModalPrices/ModalPrices";
import { UserContext } from "../../context/userContext";
import { formatNumber, lowerFare2 } from "../../services/generalSevices";
import { CurrencyContext } from "../../context/currencyContext";
import { getConvertCurrency } from "../../api/exchangeApi";
import Select, { components } from 'react-select';
import { getCollaboratorsByInfluencer } from "../../api/collaborationApi";
import { useRef } from "react";
import { postEditUserDataInfluencer } from "../../api/myAccountApi";

import avatar from "../../utils/images/avatar_fluincr.png";

export default function MyProfileFirstSection() {

    const intl = useIntl();
    const collaboratorsRef = useRef(null);
    const [showModalPrices, setShowModalPrices] = useState(false);

    const { personalFare, id, userToken, collaborators, setCollaborators } = useContext(UserContext);
    const { currency } = useContext(CurrencyContext);
    const [price, setPrice] = useState(null);

    const [collaboratorsOptions, setCollaboratorsOptions] = useState([]);

    const { Option } = components;

    const [showCollaboratorsSelect, setShowCollaboratorsSelect] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [collaboratorsImages, setCollaboratorsImages] = useState([]);

    useEffect(() => {
        //Para que un colborador pueda salir como option debera la colaboracion estar en estado cerrada
        if (id !== null) {
            getCollaboratorsByInfluencer({ influencerId: id }).then((response) => {
                const auxCollaborators = response;
                const auxImages = [];
                const auxSelectedColla = [];
                auxCollaborators.map((collaborator) => {
                    collaborator.label = collaborator.namecompany;
                    collaborator.value = collaborator.companyid;
                    if (collaborators.includes(collaborator.companyid)) {
                        auxImages.push(collaborator.imagecompany);
                        auxSelectedColla.push(collaborator);
                    }
                })
                setCollaboratorsOptions(auxCollaborators);
                setCollaboratorsImages(auxImages);
                setSelectedOptions(auxSelectedColla);
            })
        }
    }, [id])

    useEffect(() => {

        if (currency !== null) {
            if (Object.keys(personalFare).length > 0) {
                const amount = lowerFare2(personalFare);
                const auxCurrency = currency.symbol

                getConvertCurrency({ amount: amount }).then((response) => {
                    //setPrice(response[auxCurrency].toFixed(0))
                    setPrice(response[auxCurrency].toFixed(2))
                })
            }
        }

    }, [currency, personalFare])

    const IconCollaboratorOption = props => {

        return (<Option {...props}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={(props.data.imagecompany !== null) ? (props.data.imagecompany) : (avatar)}
                    style={{ width: '40px', borderRadius: '50%', marginRight: 5, border: '1px solid #E4E6EB' }}
                    alt={props.data.label}
                />
                <span >{props.data.namecompany}</span>
            </div>
        </Option>)
    };

    const sendCollaborators = () => {

        setShowCollaboratorsSelect(false);
        const selectCollaboratorsId = [];
        const selectCollaboratorsImages = [];
        selectedOptions.map((collaborators) => {
            selectCollaboratorsId.push(collaborators.companyid);
            selectCollaboratorsImages.push(collaborators.imagecompany);
        })

        postEditUserDataInfluencer({ body: { attributes: { collaborators: selectCollaboratorsId } }, token: userToken }).then((response) => {
            if (response.status === 201) {

                setCollaboratorsImages(selectCollaboratorsImages);
                setCollaborators(selectCollaboratorsId);
            }
        })
    }

    const selectStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px', boxShadow: 'none'
        }),
        option: (styles) => ({
            ...styles, display: 'flex', alignItems: 'center', background: 'transparent', color: '#000000', fontSize: '1.5rem',
            "@media(max-width: 1920px)": {
                fontSize: '1.3rem'
            },
            "@media(max-width: 1540px)": {
                fontSize: '1.1rem',
            },
            "@media(max-width: 1366px)": {
                fontSize: '0.9rem'
            }
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.5rem',
            "@media(max-width: 1920px)": {
                fontSize: '1.3rem'
            },
            "@media(max-width: 1540px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '0.9rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles,
            fontSize: '1.5rem',
            "@media(max-width: 1920px)": {
                fontSize: '1.3rem'
            },
            "@media(max-width: 1540px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '0.9rem'
            }

        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.5rem',
            "@media(max-width: 1920px)": {
                fontSize: '1.3rem'
            },
            "@media(max-width: 1540px))": {
                fontSize: '1.1rem',
            },
            "@media(max-width: 1366px)": {
                fontSize: '0.9rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E', width: '40px'
        }),
        clearIndicator: (styles) => ({
            ...styles, display: 'none'
        })
    };

    useEffect(() => {

        function handleClickOutside(event) {
            if (collaboratorsRef.current && !collaboratorsRef.current.contains(event.target)) {
                setShowCollaboratorsSelect(false);
            }

        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [collaboratorsRef])

    const emptyCollaborator = () => {
        const col = []
        for (let i = 0; i < (4 - collaboratorsImages.length); i++) {
            col.push(<div className="collaboration" key={`empty${i}`}></div>)
        }
        return (col);
    }

    return (
        <MyProfileFirstSectionContainer>

            <div className="collaborationsContainer" ref={collaboratorsRef} >
                <div className="editCollaborations">
                    <div className="collaborations">
                        {collaboratorsImages.map((image, index) => {
                            return (
                                <div className="collaboration" key={`collaborator${index}`}>
                                    <img src={(image !== null) ? image : avatar} alt="collaborator" />
                                </div>
                            )
                        })}
                        {emptyCollaborator()}
                    </div>
                    <img src={edit} alt="edit" className="editIcon" onClick={() => {
                        setShowCollaboratorsSelect(!showCollaboratorsSelect)
                    }} />
                </div>

                {/* <p className="collaborationText"><FormattedMessage id="my_profile_first_section_text_1" defaultMessage="Aquí estarán tus colaboradores" /></p> */}

                {(showCollaboratorsSelect) && (<div className="selectContainer">
                    <p className="apply" onClick={sendCollaborators}><FormattedMessage id="create_collaboration_text_6" defaultMessage="Aplicar" /></p>
                    {(collaboratorsOptions) && (
                        <Select
                            value={selectedOptions}
                            options={collaboratorsOptions}
                            defaultValue={[collaboratorsOptions[0]]}
                            components={{ Option: IconCollaboratorOption }}
                            isMulti
                            onChange={(e) => {
                                setSelectedOptions(e)
                            }}
                            isOptionDisabled={() => selectedOptions.length >= 4}
                            styles={selectStyles}
                            placeholder={intl.formatMessage({ id: "collaborators" })}

                    //defaultValue={statusOptions[statusIndex]} 
                                    /*
                                    onChange={(event) => {
                                        setSecurityQuestion(event)
                                        const auxBody = { ...body }
                                        auxBody.attributes = {
                                            ...body.attributes,
                                            securityQuestion: event.name,
                                            preguntaSeguridad: event.nombre
                                        };
                                        setBody(auxBody)
                                    }} *//>)}

                </div>)}


            </div>
            <div className="rateEdit">
                <div className="rateContainer">
                    <div className="rate">

                        <p className="rateTitle"><FormattedMessage id="my_profile_first_section_text_2" defaultMessage="Foto / Video" /></p>

                        <div className="rateInformation">
                            <p className="rateDescription"><FormattedMessage id="my_profile_first_section_text_5" defaultMessage="Desde" /> </p>
                            <div>
                                {(price === null) ? (<p className="addRate" onClick={() => { setShowModalPrices(true) }}><FormattedMessage id="my_profile_first_section_text_4" defaultMessage="Edita tu precio" /> /</p>) : (<p className="value">{currency.symbol} {formatNumber(price)} /</p>)}

                                <img src={gift} alt="gift" />
                            </div>
                        </div>
                    </div>
                </div>
                <img src={edit} alt="edit" className="editIcon" onClick={() => { setShowModalPrices(true) }} />
            </div>

            {(showModalPrices) && (<ModalPrices setShowModalPrices={setShowModalPrices} />)}

        </MyProfileFirstSectionContainer>
    )
}